import urlJoin from 'url-join';
import { API_URL } from '../environment';

export function getApiUrl(...parts: string[]) {
  return urlJoin(API_URL, ...parts);
}
